<template>
  <div>
    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-material w-100 my-4 ag-grid-table"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="bankAccounts"
      rowSelection="multiple"
      colResizeDefault="shift"
      :animateRows="true"
      :floatingFilter="true"
      :pagination="true"
      :paginationPageSize="paginationPageSize"
      :suppressPaginationPanel="true"
    ></ag-grid-vue>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import bankAccounts from "./dataBank.json";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
export default {
  components: {
    AgGridVue
  },
  data() {
    return {
      searchQuery: "",
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: "No",
          field: "no",
          width: 150,
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          pinned: "left"
        },
        {
          headerName: "Bank Account Name",
          field: "bank_account_name",
          filter: true,
          width: 225,
          pinned: "left"
        },
        {
          headerName: "Bank Name",
          field: "bank_name",
          filter: true,
          width: 250
        },
        {
          headerName: "Account Number",
          field: "account_number",
          filter: "agNumberColumnFilter",
          width: 250
        },
        {
          headerName: "Date Added",
          field: "date_added",
          filter: "agDateColumnFilter",
          width: 175
        },
        {
          headerName: "Status",
          field: "status",
          filter: true,
          width: 150
        }
      ],
      bankAccounts: bankAccounts
    };
  },
  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 50;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      }
    }
  }
};
</script>

<style>
</style>
